import React from "react";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { useNavigate } from "react-router-dom";
import { Paper, Stack, Typography } from "@mui/material";
import { LoadNormalizedCargos } from "../../../../../../domain/usecases/load-normalized-cargos";
import {
  NormalizedCargo,
  Route,
} from "../../../../../../domain/models/cargo-model";
import { useDispatch } from "react-redux";
import { SeparationState, separationActions } from "../../store";
import { useSelector } from "react-redux";
import { useErrorHandler } from "../../../../hooks";

type Props = {
  loadCargos: LoadNormalizedCargos;
};

export const Main = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleError = useErrorHandler((error) => {
    alert("Erro Inesperado");
  });

  const cargos = useSelector<SeparationState, NormalizedCargo[]>(
    (state) => state.cargos
  );

  React.useEffect(() => {
    async function fetch() {
      var initialDate = new Date();
      let endDate = new Date();
      initialDate.setDate(initialDate.getDate() - 2);
      endDate.setDate(endDate.getDate() - 1);
      try {
        const warehouseString = localStorage.getItem("currentWarehouse");
        const warehouse = warehouseString
          ? (JSON.parse(warehouseString) as {
              id: number;
              name: string;
            } | null)
          : undefined;
        const data = await props.loadCargos.load(warehouse!.id, {
          date: new Date(Date.now()).toDateString(),
        });
        const delayedCargos = await props.loadCargos.load(warehouse!.id, {
          status: ["NOT_CHECKED", "PENDING"],
          dateRange: [
            initialDate.toISOString().slice(0, 10),
            endDate.toISOString().slice(0, 10),
          ],
        });
        let hasSeparated = false;
        let hasNotSeparated = false;
        delayedCargos.forEach((cargo) => {
          cargo.cargoItems.forEach((item) => {
            item.inventoryReservations?.forEach((reservation) => {
              if (reservation.status === "NOT_SEPARATED") {
                hasNotSeparated = true;
              }
              if (reservation.status === "SEPARATED") {
                hasSeparated = true;
              }
            });
          });

          if (hasSeparated && hasNotSeparated) {
            data.push(cargo);
          }
          if (hasNotSeparated && !hasSeparated) {
            data.push(cargo);
          }
        });

        dispatch(separationActions.saveCargos({ cargos: data }));
      } catch (error) {
        handleError(error as Error);
      }
    }

    fetch();
  }, []);

  const outputArr: any[] = [];

  cargos.forEach((obj) => {
    const index = outputArr.findIndex((o) => o.route === obj.route);
    if (index !== -1) {
      outputArr[index].count++;
    } else {
      outputArr.push({ route: obj.route, count: 1 });
    }
  });

  return (
    <>
      <DrawerAppBar
        title="Separar Mercadoria"
        onBack={() => {
          navigate("/mobile/tasks");
        }}
      />
      {/* <Total text="Total de Mercadorias a Guardar" number={"3"} /> */}
      <Stack sx={{ m: "20px" }} spacing={4}>
        {outputArr.length === 0 && (
          <Typography>Não há cargas a serem separadas</Typography>
        )}
        {outputArr.map((route) => {
          return (
            <Paper
              sx={{
                py: "30px",
                px: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              key={route.route}
              onClick={() => {
                dispatch(
                  separationActions.setCurrentRoute({ route: route.route })
                );
                navigate(`/mobile/separation/route`);
              }}
            >
              <Typography variant="h5" fontWeight={"bold"}>
                {route.route === Route.saoMateus ? "SÃO MATEUS" : route.route}
              </Typography>
              <Typography variant="h5">{route.count}</Typography>
            </Paper>
          );
        })}
      </Stack>
    </>
  );
};
